<template>
  <!-- 外层容器 -->
  <div class="w-full h-auto pt-[3.75vw] bg-[#F5F5F7]">
    <!-- 标题区域 -->
    <div
      class="relative w-full h-auto mx-auto mb-[2vw] flex flex-col justify-center gap-[0.42vw]"
    >
      <!-- 主标题框 -->
      <div class="h-[3.3vw] flex flex-col justify-center items-center">
        <div
          class="text-[2.71vw] text-[#1A2233] font-harmony font-bold leading-[3.25vw] text-center"
        >
          课外课程体系-<span class="text-[#F28334] font-bold">研学路线</span>
        </div>
      </div>
    </div>

    <!-- 内容区域 -->
    <div class="w-[61.46vw] mx-auto flex flex-col gap-[0.1vw]">
      <!-- 表头 -->
      <div
        class="flex items-center justify-between w-full h-[4.1vw] mb-[0.1vw] gap-[0.1vw] font-harmony font-medium text-[1.25vw] text-[#FFFFFF]"
      >
        <span
          class="flex items-center justify-center w-[15.63vw] h-[4.1vw] rounded-tl-[0.42vw] bg-[#949CAC]"
        >
          时 间
        </span>
        <span
          class="flex items-center justify-center flex-1 h-[4.1vw] bg-[#949CAC]"
        >
          活 动 内 容
        </span>
        <span
          class="flex items-center justify-center w-[15.63vw] h-[4.1vw] rounded-tr-[0.42vw] bg-[#949CAC]"
        >
          地 点
        </span>
      </div>

      <!-- 内容 -->
      <div
        v-for="(item, index) in tableData"
        :key="index"
        :class="[
          'flex w-full h-[4.1vw] hover:bg-[#F5F7FA] transition-colors duration-500',
          index % 2 === 0 ? 'bg-white' : 'bg-[#F9F9FF]',
        ]"
      >
        <!-- 时间段 -->
        <div class="flex items-center justify-center w-[15.63vw] gap-[0.3vw]">
          <i
            class="el-icon-alarm-clock text-[0.83vw] text-[#F28334] font-bold"
          ></i>
          <span
            class="font-harmony font-bold italic text-[0.83vw] text-[#1A2233]"
          >
            {{ item.date }}
          </span>
        </div>
        <div class="w-[0.1vw] h-full bg-white"></div>
        <!-- 活动内容 -->
        <div
          class="flex-1 flex flex-col items-start justify-center px-[2.5vw] gap-[0.42vw]"
        >
          <div
            class="bg-[#05358C] text-white rounded w-[5.83vw] px-[0.4vw] py-[0.25vw] inline-block text-center text-[0.83vw] font-medium font-harmony"
          >
            {{ item.name.title }}
          </div>
          <div class="text-[#676B73] text-[0.73vw] font-harmony font-normal">
            - {{ item.name.desc }}
          </div>
        </div>
        <div class="w-[0.1vw] h-full bg-white"></div>
        <!-- 地点 -->
        <div class="flex items-center justify-center w-[15.63vw]">
          <span
            class="bg-[#F28334] text-white rounded w-[5.83vw] px-[0.4vw] py-[0.25vw] inline-block text-center text-[0.83vw] font-medium font-harmony"
          >
            {{ item.address }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "coursesystem-module4",
  data() {
    return {
      tableData: [
        {
          date: "08:30 – 09:00",
          name: {
            title: "集 合",
            desc: "分组、安全须知讲解",
          },
          address: "西工大校门口",
        },
        {
          date: "09:00 – 09:40",
          name: {
            title: "探秘科研殿堂",
            desc: "参观西工大实验室",
          },
          address: "西工大实验室",
        },
        {
          date: "09:50 – 10:30",
          name: {
            title: "航空历史之旅",
            desc: "参观西工大航空博物馆，了解中国航空发展里程碑",
          },
          address: "航空博物馆",
        },
        {
          date: "10:40 – 11:20",
          name: {
            title: "专 家 面 谈",
            desc: "西工大教授/工程师主题讲座",
          },
          address: "多媒体报告厅",
        },
        {
          date: "11:30 – 12:30",
          name: {
            title: "校园午餐体验",
            desc: "西工大学生食堂用餐，感受高校生活",
          },
          address: "学 生 食 堂",
        },
        {
          date: "12:40 – 13:40",
          name: {
            title: "动手实践课",
            desc: "分组组装航空模型/简易无人机，讲师指导调试",
          },
          address: "活 动 中 心",
        },
        {
          date: "13:50 – 14:30",
          name: {
            title: "飞行挑战赛",
            desc: "模型飞行比赛（距离、稳定性评定），无人机基础操作教学",
          },
          address: "户 外 操 场",
        },
        {
          date: "14:40 – 15:10",
          name: {
            title: "无人机表演秀",
            desc: "无人飞手展示无人机特技飞行，拉烟环飞行特效",
          },
          address: "户外操场",
        },
        {
          date: "15:10 – 15:30",
          name: {
            title: "总结与留影",
            desc: "总结研学活动，合影留念",
          },
          address: "标志性建筑前",
        },
      ],
    };
  },
  mounted() {
    // console.log("tableData:", this.tableData);
  },
};
</script>

<style scoped>
</style>